import {handleActions} from 'redux-actions';

import * as actionTypes from 'web-app/react/constants/action-types';

import * as Actions from '../actions';

export const accountReducer = handleActions(
    {
        [actionTypes.FETCH_ACCOUNT_SUCCESS]: (state, action) => {
            return {
                ...state,
                ...action.payload,
            };
        },
        [actionTypes.FILE_UPLOAD_FILE_PERSIST_SUCCESS]: (state, action) => {
            const payload = action.payload;

            if (!payload.config || !payload.persistedFile) {
                return state;
            }

            const config = payload.config;

            if (config.type === 'login' && config.loginId === state.loginId && payload.persistedFile) {
                return {
                    ...state,
                    image: {
                        ...payload.persistedFile,
                    },
                };
            } else {
                return state;
            }
        },
        [Actions.didSetPincode.type]: state => {
            if (state.missingPin) {
                return {
                    ...state,
                    missingPin: false,
                };
            } else {
                return state;
            }
        },
        [Actions.closeSurvey.type]: state => {
            return {
                ...state,
                hideSurveyModal: false,
            };
        },
        [Actions.getQRSigninBehaviorSuccess.type]: (state, action) => {
            const payload = action.payload;
            if (payload) {
                return {
                    ...state,
                    isQrSigninEnabled: payload.isEnabled,
                    canManageQrSignin: payload.canManage,
                };
            } else {
                return state;
            }
        },
    },
    {hideSurveyModal: true},
);
